import React, { useEffect, useState } from "react";
import Layout from "../Componants/Layout";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest } from "../services/apiMethods";
import {
  filterTheArray,
  getQueryParams,
  getTheDays,
} from "../utils/HelperFunctions";
import Leadsdetail from "../Componants/Leadsdetail";
import { useLeadDetail } from "../context/LeadDetailProvider";
import { Spinner } from "react-bootstrap";
import moment from "moment";

export default function Leads() {
  const Navigate = useNavigate();
  const Location = useLocation();
  const queryParams = getQueryParams(Location?.search);
  const { leadId, id: ID } = queryParams;
  const idSelect = leadId ? leadId : ID;
  const { leadDetailId, setLeadDetailId, leadFetch } = useLeadDetail();
  const [initialDAta, setInitialData] = useState({});
  const [listLoaders, setListLoaders] = useState(false);
  const [seenIds, setSeenIds] = useState(new Set()); // Track seen IDs
  const [activeSection, setActiveSection] = useState("left");

  const handleSelect = (detailId) => {
    setActiveSection("right");
    setLeadDetailId(detailId);
    setSeenIds((prevSeen) => new Set(prevSeen).add(detailId));
    Navigate(`/leads?id=${detailId}`);
  };

  const handleBackToList = () => {
    setActiveSection("left"); // Switch back to the left side (leads list)
  };

  const {
    mutate: fetchLeadsDetailById,
    data: leadsbyIdData,
    isLoading,
  } = useMutation({
    mutationFn: (id) => {
      if (Location.search) {
        return getRequest(`/lead/details?id=${idSelect}`);
      } else {
        return getRequest(`/lead/details?id=${id}`);
      }
    },
    onSuccess: (data) => {
      if (data?.statusCode == 200) {
        setInitialData(data?.data);
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });

  const {
    mutate: getTheLeadsList,
    data: LeadsList,
    isLoading: apiState,
  } = useMutation({
    mutationFn: () => {
      setListLoaders(true);
      return getRequest("/lead/view");
    },
    onSuccess: (data) => {
      if (data?.statusCode === 200 && data?.data?.leads?.length > 0) {
        if (Location?.search) {
          setLeadDetailId(data?.data?.leads[0]._id);
        } else {
          fetchLeadsDetailById(data?.data?.leads[0]._id);
          setLeadDetailId(data?.data?.leads[0]._id);
          setSeenIds((prevSeen) =>
            new Set(prevSeen).add(data?.data?.leads[0]._id)
          );
        }
        setTimeout(() => {
          setListLoaders(false);
        }, 500);
      } else {
        setTimeout(() => {
          setListLoaders(false);
        }, 500);
      }
    },
    onError: (error) => {
      console.error("Error during API call:", error);
      setTimeout(() => {
        setListLoaders(false);
      }, 500);
    },
  });

  useEffect(() => {
    getTheLeadsList();
  }, [leadFetch]);

  useEffect(() => {
    if (Location?.search) {
      fetchLeadsDetailById(Location?.search);
    }
  }, [Location?.search]);

  const hanleRefresh = () => {
    getTheLeadsList();
  };

  return (
    <>
      <Layout>
        {/* <div className="commn-dubble-side res-right-side res-left-side"> */}

        <div className="commn-dubble-side  main-cont-box">
          {listLoaders ? (
            <div className="comnn-card-side spinner-card-side">
              <div className="leads-pending-contain">
                <div className="Lead-Loader">
                  <Spinner animation="border" variant="primary" />
                </div>
              </div>
            </div>
          ) : (
            <div
              className={`comnn-card-side res-left-side  ${activeSection === "left" ? "active-mobile" : "hidden-mobile"
                }`}
            >
              <div className="comnn-card-title">
                <div>
                  {LeadsList?.data?.totalLeads == 1 ? (
                    <h2>1 Lead Pending</h2>
                  ) : (
                    <h2>{LeadsList?.data?.totalLeads} Leads Pending</h2>
                  )}
                  <p>
                    {LeadsList?.data?.recentLeads} new leads in the last 24
                    hours
                  </p>
                </div>
                <button onClick={() => hanleRefresh()}>
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="20" cy="20" r="20" fill="white" />
                    <path
                      d="M26.042 19.521C26.042 23.1224 23.1224 26.042 19.521 26.042C15.9195 26.042 13 23.1224 13 19.521C13 15.9195 15.9195 13 19.521 13C21.7035 13 23.6356 14.0722 24.8193 15.7187"
                      stroke="black"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M22.7815 16.3159L25.3909 16.3528L25.9997 13.8151"
                      stroke="black"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <ul className="leads-pending-contain">
                {Array.isArray(LeadsList?.data?.leads) &&
                  LeadsList?.data?.leads?.length > 0 ? (
                  LeadsList?.data?.leads.map((ele, index) => (
                    <li
                      className={
                        idSelect
                          ? idSelect === ele?._id
                            ? "activess"
                            : ""
                          : leadDetailId === ele?._id
                            ? "activess"
                            : ""
                      }
                      key={index}
                      onClick={() => handleSelect(ele?._id)}
                    >
                      <div className="leads-pending-card">
                        <div className="leads-pending-pro">
                          <div className="pending-pro-view">
                            {ele?.customer?.image ? (
                              <img src={ele?.customer?.image} />
                            ) : (
                              <div class="custom-circle">
                                <span className="inside-custom-circle">
                                  {ele?.name
                                    ? ele?.name.toUpperCase().at(0)
                                    : "N"}
                                </span>
                              </div>
                            )}
                            <div>
                              <h3>{ele?.customer?.name || "N/A"}</h3>
                              {ele?.city ||
                                `${filterTheArray(
                                  ele?.address
                                )}, ${ele?.postCode?.slice(0, 3)}`}
                            </div>
                          </div>
                          {/* <span>{getTheDays(ele?.createdAt)}</span> */}

                           {ele?.createdAt && <span>
                                          {moment(ele?.createdAt).format("DD MMMM YYYY")}
                                        </span>}
                        </div>

                        <div className="pending-pro-data">
                          <h3>{ele?.service?.serviceName}</h3>
                          <p>{ele?.category?.categoryName}</p>
                          <ul>

                            {ele?.customer?.isPhoneNoVerified &&
                            <li>
                              <p>
                                Verified Phone
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <rect
                                    width="14"
                                    height="14"
                                    rx="7"
                                    transform="matrix(-1 0 0 1 15 1)"
                                    stroke="#27CA40"
                                  />
                                  <path
                                    d="M11.0625 6.37425L6.82939 9.96884L4.9375 8.07695"
                                    stroke="#27CA40"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </p>
                            </li>}
                            <li>
                              <p>
                                Verified Email{" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <rect
                                    width="14"
                                    height="14"
                                    rx="7"
                                    transform="matrix(-1 0 0 1 15 1)"
                                    stroke="#27CA40"
                                  />
                                  <path
                                    d="M11.0625 6.37425L6.82939 9.96884L4.9375 8.07695"
                                    stroke="#27CA40"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </p>
                            </li>
                          </ul>
                          <div className="list-flex">
                            <div className="pending-pro-quote">
                              <p>
                                <img
                                  src={require("../assets/images/sparkquates.png")}
                                  alt="icn6"
                                />

                                1 Quote
                              </p>
                            </div>
                            <div className="list-circle">
                              <ul>
                                {[...Array(5)].map((_, index) => (
                                  <li key={index} className={index < ele?.response ? "active-responce" : ""}></li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>

                        <div className="pending-pro-quote"></div>
                        {ele?.isRead ? null : (
                          <>
                            {!seenIds.has(ele?._id) && ( // Conditionally render the SVG
                              <span className="active-shape">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="45"
                                  height="45"
                                  viewBox="0 0 45 45"
                                  fill="none"
                                >
                                  <path
                                    d="M0 15C0 6.71573 6.71573 0 15 0H45L22.5 22.5L0 45V15Z"
                                    fill="#337FE0"
                                  />
                                </svg>
                              </span>
                            )}
                          </>
                        )}
                      </div>
                    </li>
                  ))
                ) : (
                  <div>{/* No Data Found */}</div>
                )}
              </ul>
            </div>
          )}
          <div
            className={`comnn-layout-side res-right-side  ${activeSection === "right" ? "active-mobile" : "hidden-mobile"
              }`}
          >
            <div className="back-res-btn" onClick={handleBackToList}>
              {" "}
              <span>
                <svg
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 7L1.29289 6.29289L0.585786 7L1.29289 7.70711L2 7ZM17 8C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6V8ZM7.29289 0.292893L1.29289 6.29289L2.70711 7.70711L8.70711 1.70711L7.29289 0.292893ZM1.29289 7.70711L7.29289 13.7071L8.70711 12.2929L2.70711 6.29289L1.29289 7.70711ZM2 8H17V6H2V8Z"
                    fill="black"
                  />
                </svg>
              </span>
            </div>
            {Location.search || !listLoaders ? (
              <Leadsdetail initialDAta={initialDAta} idSelect={idSelect} />
            ) : null}
          </div>
        </div>
      </Layout>
    </>
  );
}
